const colors = {
  /* Primary Colors for Base and Text */
  primaryBlack: "#333333", // Dark base for text
  primaryWhite: "#ffffff", // Main background color

  /* Gradient Colors */
  gradientStart: "#ff7e5f", // Starting color of the gradient
  gradientEnd: "#feb47b", // Ending color of the gradient

  /* Secondary Colors */
  secondaryYellow: "#ffbe70", // Warm, inviting secondary color
  secondaryRed: "#feb47b", // For alerts or important notifications
  secondaryRedTransparent: "#ffcda79b", // For navbar

  /* Accent Colors */
  accentLightGrey: "#d3d3d3", // For borders or subtle elements
  accentNeonBlue: "#0051ff", // Vibrant accent color for CTAs

  /* Neutral Colors */
  neutralLight: "#f5f5f5", // Light background for sections
  neutralDark: "#383c43", // Darker background for contrast
};

export default colors;
